import React, { useState, useEffect } from 'react';
import { Col, Row, Image } from 'react-bootstrap';
//import Pencil from "../../../assets/images/pencil.png";
//import EditCodeViolationsModal from "../../learning/admin/EditCodeViolationsModal";
import EthicsCounsellorEditModal from '../admin/EthicsCounsellorEditModal';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import {
  GetCompanyList,
  selectCompanyList
} from '../../../features/helpandassistance/companyListSlice';
import {
  GetLocationList,
  selectLocationList
} from '../../../features/helpandassistance/locationListSlice';
import {
  GetCounsellorSearch,
  selectCounsellorSearch
} from '../../../features/helpandassistance/counsellorSearchSlice';
import {
  CounsellorModel,
  GetCounsellors,
  selectCounsellors
} from '../../../features/helpandassistance/counsellorSlice';
import { isAdmin, isPermited } from '../../../features/localStorage';
import TableList from '../modals/table/EditEthicsCounsellorsListTable';
import GoBack from '../../../assets/images/arrow-go-back.svg';
import EthicsTableList from '../modals/table/FindMyEthicsConsellorsTable';

interface CounsellorProps {
  counsellors: CounsellorModel[];
}
const EthicsCounsellor: React.FC<CounsellorProps> = ({
  counsellors
}: CounsellorProps) => {
  const CompanyList = useAppSelector(selectCompanyList);
  const LocationList = useAppSelector(selectLocationList);
  const Counsellor = useAppSelector(selectCounsellorSearch);

  const dispatch = useAppDispatch();

  const [companyId, setCompanyId] = useState();
  const [locationId, setLocationId] = useState();
  const [search, setSearch] = useState(true);

  useEffect(() => {
    // async function fetchCounsellors() {
    //    await dispatch(GetCounsellors());
    // }
    // fetchCounsellors();

    async function fetchCompanyData() {
      let sample = await dispatch(GetCompanyList());
    }
    fetchCompanyData();
  }, [companyId]);

  // useEffect(() => {
  //   async function fetchLocationData() {
  //     let sample = await dispatch(GetLocationList(companyId));
  //   }
  //   fetchLocationData();
  // }, [companyId]);

  const SearchCouncellor = () => {
    const data = { company: companyId, location: locationId };
    async function fetchSearch() {
      await dispatch(GetCounsellorSearch(data));
    }
    fetchSearch();
    setSearch(false);
  };
  const resetSearch = () => {
    setSearch(true);
  };

  const CompanyId = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const groupId: any = event.target.value;
    setCompanyId(groupId);
    // console.log(groupId);
    dispatch(GetLocationList(groupId));
  };
  const LocationId = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const name: any = event.target.value;
    setLocationId(name);
  };
  return (
    <>
      <Row>
        <Col sm={6}>
          <h3 style={styles.heading}>Find my Ethics Counsellor</h3>
        </Col>
        <Col sm={6} className='desk'>
          {isPermited(9, 3) && (
            <span style={{ float: 'right', cursor: 'pointer' }}>
              <EthicsCounsellorEditModal
                counsellor={counsellors}
                label='Edit ethics counsellors list'
                isForEdit={true}
                isListShow={false}
              />
            </span>
          )}
        </Col>
      </Row>

      <Row>
        <Col sm={8}>
          <p style={styles.details}>
            Get the contact details of the Ethics Counsellor assigned to your
            location. You can also view the{' '}
            <EthicsCounsellorEditModal
              counsellor={counsellors}
              label='Ethics Counsellors list'
              isForEdit={false}
              isListShow={true}
            />{' '}
            and search for the counsellors.
          </p>
        </Col>
        <Col sm={4}>
          {!search && (
            <span style={styles.link} onClick={resetSearch}>
              <Image src={GoBack} /> RESET SEARCH
            </span>
          )}
        </Col>
      </Row>

      {search ? (
        <Row>
          <Col xs={12} sm={3} className='pb-3'>
            <form>
              <select
                id='company'
                name='company'
                onChange={CompanyId}
                className='shadow-none d-inline-block'
                style={{
                  backgroundColor: 'white',
                  border: 'solid 1px #e4e4e4',
                  width: '100%',
                  fontFamily: 'Saira',
                  fontSize: '16px',
                  color: '#6d6e71',
                  borderRadius: '0px'
                }}
              >
                <option value=''>Select Your Company</option>
                {CompanyList?.length > 0 ? (
                  CompanyList?.map((val: any) => (
                    <option key={val.groupId} value={val.groupId}>
                      {' '}
                      {val.name}{' '}
                    </option>
                  ))
                ) : (
                  <option style={styles.text1}>No Records Available</option>
                )}
              </select>
            </form>
          </Col>
          <Col xs={12} sm={3} className='pb-3'>
            <form>
              <select
                id='location'
                name='location'
                onChange={LocationId}
                className='shadow-none d-inline-block'
                style={{
                  backgroundColor: 'white',
                  border: 'solid 1px #e4e4e4',
                  borderRadius: '0px',
                  width: '100%',
                  fontFamily: 'Georama-Regular',
                  fontSize: '16px',
                  color: '#6d6e71'
                }}
              >
                <option value='location'>Select Your Office's Location</option>
                {LocationList?.length > 0 ? (
                  LocationList?.map((val: any) => (
                    <option key={val.id} value={val.id}>
                      {val.location}{' '}
                    </option>
                  ))
                ) : (
                  <option style={styles.text1}>No Records Available</option>
                )}
              </select>
            </form>
          </Col>
          <Col xs={6} sm={4}></Col>
          <Col xs={6} sm={2}>
            <button
              className='button'
              onClick={SearchCouncellor}
              style={styles.button}
            >
              SUBMIT
            </button>
          </Col>
        </Row>
      ) : (
        <EthicsTableList tData={Counsellor} />
      )}
    </>
  );
};

const styles: any = {
  heading: {
    fontFamily: 'Georama-Regular',
    fontSize: '24px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    marginBottom: '26px'
  },

  subHeading: {
    fontFamily: 'Georama-Regular',
    fontSize: '18px',
    fontWeight: 600,
    fontStretch: 'normal',
    fontStyle: 'normal',
    marginTop: '10px',
    marginBottom: '26px'
  },
  details: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontWeight: 'normal',
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.5
  },
  helpline: {
    fontFamily: 'Georama-Regular',
    fontSize: '16px',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontStretch: 'normal',
    paddingLeft: '15px',
    paddingRight: '15px',
    textAlign: 'left'
  },
  button: {
    padding: '15px 15px',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: 500,
    fontStretch: 'normal',
    fontStyle: 'normal',
    margin: '0px',
    width: '100%'
  },
  link: {
    float: 'right',
    fontFamily: 'Georama-Regular',
    fontSize: '12px',
    fontWeight: '600',
    color: '#e31837',
    lineHeight: '2'
  }
};

export default EthicsCounsellor;
